import { Legend } from '../component/bi-analysis-result-view/bi-analysis-table/flat-table/model/legend';

export class Download {
    filename: string;
    contentType: string;
    contentDisposition: string;
    base64String: string;
    legend: Legend;

    constructor( filename: string, contentType: string, contentDisposition: string, base64String: string, legend: Legend ) {
        this.filename = filename;
        this.contentType = contentType;
        this.contentDisposition = contentDisposition;
        this.base64String = base64String;
        this.legend = legend;
    }
}
